import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const pdsImageCss = ":host{--dimension-aspect-ratio:auto;display:inline-block}img{aspect-ratio:var(--dimension-aspect-ratio)}";
const PdsImageStyle0 = pdsImageCss;

const PdsImage$1 = /*@__PURE__*/ proxyCustomElement(class PdsImage extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.alt = '';
        this.componentId = undefined;
        this.height = undefined;
        this.loading = 'eager';
        this.sizes = undefined;
        this.src = undefined;
        this.srcset = undefined;
        this.width = undefined;
    }
    render() {
        return (h(Host, { key: '784f2478acc28f043613c4c8fa67b5bef85820b1', class: {
                'pds-image': true,
            }, id: this.componentId }, h("img", { key: '766a8230a6ea0ae45746fae832206785f963d215', alt: this.alt, height: this.height, loading: this.loading, sizes: this.sizes, src: this.src, srcset: this.srcset, width: this.width })));
    }
    static get style() { return PdsImageStyle0; }
}, [1, "pds-image", {
        "alt": [1],
        "componentId": [1, "component-id"],
        "height": [2],
        "loading": [1],
        "sizes": [1],
        "src": [1],
        "srcset": [1],
        "width": [2]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-image"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-image":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsImage$1);
            }
            break;
    } });
}

const PdsImage = PdsImage$1;
const defineCustomElement = defineCustomElement$1;

export { PdsImage, defineCustomElement };

//# sourceMappingURL=pds-image.js.map